import React from 'react';

export const ChatIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 18 18'
      focusable='false'
      width={width}
      height={height}
      className='icon icon-chat'
      {...rest}
    >
      <path
        d='M13 5.70503V11.949C13 12.3352 12.8466 12.7055 12.5735 12.9786C12.3005 13.2516 11.9302 13.405 11.544 13.405L6.5 13.426L3.544 16.675V13.426H1.456C1.06984 13.426 0.699505 13.2726 0.426453 12.9996C0.1534 12.7265 0 12.3562 0 11.97V5.72603C0 5.33987 0.1534 4.96953 0.426453 4.69648C0.699505 4.42343 1.06984 4.27003 1.456 4.27003L11.54 4.24903C11.7315 4.2485 11.9213 4.28577 12.0984 4.35871C12.2755 4.43165 12.4365 4.53881 12.5721 4.67406C12.7078 4.80932 12.8154 4.97 12.8888 5.14692C12.9622 5.32383 13 5.51349 13 5.70503Z'
        fill={fill || '#EBBA16'}
      />
      <path
        d='M6.498 7.49803H2.663C2.61988 7.50558 2.57562 7.50361 2.53335 7.49224C2.49107 7.48087 2.45179 7.46039 2.41827 7.43223C2.38475 7.40407 2.3578 7.36892 2.33931 7.32924C2.32082 7.28956 2.31123 7.24631 2.31123 7.20253C2.31123 7.15875 2.32082 7.1155 2.33931 7.07582C2.3578 7.03614 2.38475 7.00098 2.41827 6.97282C2.45179 6.94466 2.49107 6.92418 2.53335 6.91281C2.57562 6.90145 2.61988 6.89947 2.663 6.90703H6.503C6.54612 6.89947 6.59038 6.90145 6.63265 6.91281C6.67493 6.92418 6.71421 6.94466 6.74773 6.97282C6.78125 7.00098 6.8082 7.03614 6.82669 7.07582C6.84518 7.1155 6.85477 7.15875 6.85477 7.20253C6.85477 7.24631 6.84518 7.28956 6.82669 7.32924C6.8082 7.36892 6.78125 7.40407 6.74773 7.43223C6.71421 7.46039 6.67493 7.48087 6.63265 7.49224C6.59038 7.50361 6.54612 7.50558 6.503 7.49803H6.498Z'
        fill='#fff'
      />
      <path
        d='M10.338 9.27002H2.663C2.59347 9.25784 2.53046 9.22153 2.48506 9.16748C2.43965 9.11343 2.41476 9.0451 2.41476 8.97452C2.41476 8.90393 2.43965 8.8356 2.48506 8.78155C2.53046 8.7275 2.59347 8.6912 2.663 8.67902H10.342C10.4115 8.6912 10.4745 8.7275 10.5199 8.78155C10.5653 8.8356 10.5902 8.90393 10.5902 8.97452C10.5902 9.0451 10.5653 9.11343 10.5199 9.16748C10.4745 9.22153 10.4115 9.25784 10.342 9.27002H10.338Z'
        fill='#fff'
      />
      <path
        d='M10.338 11.043H2.663C2.59347 11.0308 2.53046 10.9945 2.48506 10.9405C2.43965 10.8864 2.41476 10.8181 2.41476 10.7475C2.41476 10.6769 2.43965 10.6086 2.48506 10.5546C2.53046 10.5005 2.59347 10.4642 2.663 10.452H10.342C10.4115 10.4642 10.4745 10.5005 10.5199 10.5546C10.5653 10.6086 10.5902 10.6769 10.5902 10.7475C10.5902 10.8181 10.5653 10.8864 10.5199 10.9405C10.4745 10.9945 10.4115 11.0308 10.342 11.043H10.338Z'
        fill='#fff'
      />
      <path
        d='M15.675 1.021L5.59099 1C5.20484 1 4.8345 1.1534 4.56145 1.42645C4.28839 1.69951 4.13499 2.06984 4.13499 2.456V4.264L11.535 4.249C11.7266 4.24834 11.9165 4.28552 12.0937 4.35839C12.2709 4.43127 12.432 4.53841 12.5678 4.67368C12.7035 4.80895 12.8112 4.96968 12.8847 5.14666C12.9582 5.32363 12.996 5.51337 12.996 5.705V11.152L15.064 13.426V10.177H15.676C15.8675 10.1774 16.0571 10.14 16.2341 10.067C16.4111 9.99404 16.572 9.88685 16.7075 9.75161C16.843 9.61637 16.9505 9.45573 17.0239 9.27888C17.0972 9.10204 17.135 8.91246 17.135 8.721V2.477C17.135 2.28546 17.0972 2.0958 17.0238 1.91889C16.9504 1.74198 16.8428 1.58129 16.7071 1.44604C16.5715 1.31078 16.4105 1.20362 16.2334 1.13068C16.0563 1.05775 15.8665 1.02047 15.675 1.021Z'
        fill={fill || '#27AE60'}
      />
    </svg>
  );
};

ChatIcon.defaultProps = {
  width: 18,
  height: 18
};

export default ChatIcon;
